module.exports = __webpack_public_path__ + "static/geryon-b8876b337ee8b5edab1712b570fa9b6b.png";